import React from "react";
import { Field, reduxForm, formValueSelector } from "redux-form";
import Form from "react-bootstrap/Form";
import Alert from "react-bootstrap/Alert";
import { connect } from "react-redux";
import FieldFileInput from "./FileField";
import PropTypes from "prop-types";

class DiaryForm extends React.Component {
  renderError({ error, touched }) {
    if (touched && error) {
      return (
        <i className="fad fa-exclamation-circle" style={{ color: "red" }}></i>
      );
    }
  }

  renderInput = ({ input, label, meta }) => {
    let classes = meta.touched && meta.invalid ? "error" : "";
    let as =
      input.name === "title" || input.name === "clear" ? "input" : "textarea";
    let placeholder;
    if (label) {
      placeholder =
        this.props.mode === "edit" ? label.replace("Enter", "New") : label;
    }

    return (
      <Form.Group>
        <Form.Label>{label}</Form.Label>
        <Form.Control
          as={as}
          autoComplete="off"
          placeholder={placeholder}
          className={classes}
          {...input}
        />
        {this.renderError(meta)}
      </Form.Group>
    );
  };

  onSubmit = (formValues) => {
    this.props.onSubmit(formValues);
  };
  render() {
    return (
      <Form id="diary-form" onSubmit={this.props.handleSubmit(this.onSubmit)}>
        <Field name="title" component={this.renderInput} label="Enter title" />
        <Field name="text" component={this.renderInput} label="Enter text" />
        {this.props.mode === "edit" && this.props.image ? (
          <React.Fragment>
            <label htmlFor="clear">
              <small>Clear</small>
            </label>
            <Field name="clear" id="clear" component="input" type="checkbox" />
          </React.Fragment>
        ) : null}
        {!this.props.clear && this.props.mode === "edit" ? (
          <>
            <Field name="image" component={FieldFileInput} label="New Image" />
            <Alert className="small" variant="info">
              Image of size > 1MB will take much time to upload.
            </Alert>
          </>
        ) : null}
        {this.props.mode === "create" ? (
          <React.Fragment>
            <label htmlFor="upload">
              <small>Add image?</small>
            </label>
            <Field
              name="upload"
              id="upload"
              component="input"
              type="checkbox"
            />
          </React.Fragment>
        ) : null}
        {this.props.upload ? (
          <>
            <Field name="image" component={FieldFileInput} label="Upload" />
            <Alert className="small" variant="info">
              Image of size > 1MB will take much time to upload.
            </Alert>
          </>
        ) : null}
      </Form>
    );
  }
}

const validate = ({ title, text, image }) => {
  const errors = {};
  if (!title || title.trim() === "") {
    errors.title = "Required";
  }

  if (!text || text.trim() === "") {
    errors.text = "Required";
  }
  return errors;
};

DiaryForm.propTypes = {
  mode: PropTypes.oneOf(["create", "edit"]),
  onSubmit: PropTypes.func,
};

const CreateForm = (props) => <DiaryForm {...props} mode="create" />;
const EditForm = (props) => <DiaryForm {...props} mode="edit" />;

// CREATE FORM

const createFormSelector = formValueSelector("diaryCreateForm");
export const DiaryCreateForm = connect((state) => ({
  upload: createFormSelector(state, "upload"),
}))(
  reduxForm({
    form: "diaryCreateForm",
    validate: validate,
  })(CreateForm)
);

// EDIT FORM
const editFormselector = formValueSelector("diaryEditForm");

const mapStateToProps = (state) => {
  let currentDiary = state.diaries.currentDiary;
  // diaries: { currentDiary }
  return {
    initialValues: {
      title: currentDiary.title,
      text: currentDiary.text,
      image: currentDiary.image,
      clear: false,
    },
    clear: editFormselector(state, "clear"),
    image: editFormselector(state, "image"),
  };
};

export const DiaryEditForm = connect(mapStateToProps)(
  reduxForm({
    form: "diaryEditForm",
    validate: validate,
    enableReinitialize: true,
  })(EditForm)
);

// Decorate with connect to read form values
// const selector = formValueSelector("selectingFormValues"); // <-- same as form name
// SelectingFormValuesForm = connect((state) => {
//   // can select values individually
//   const hasEmailValue = selector(state, "hasEmail");
//   const favoriteColorValue = selector(state, "favoriteColor");
//   // or together as a group
//   const { firstName, lastName } = selector(state, "firstName", "lastName");
//   return {
//     hasEmailValue,
//     favoriteColorValue,
//     fullName: `${firstName || ""} ${lastName || ""}`,
//   };
// })(SelectingFormValuesForm);
